import { gql } from '@at/sauron-platform-graphql'

export const SearchResultsListingsGridQueryGql = gql`
    query SearchResultsListingsGridQuery(
        $filters: [FilterInput!]!
        $channel: Channel!
        $page: Int
        $sortBy: SearchResultsSort
        $listingType: [ListingType!]
        $searchId: String!
        $useGridLayout: Boolean!
    ) {
        searchResults(
            input: {
                facets: []
                filters: $filters
                channel: $channel
                page: $page
                sortBy: $sortBy
                listingType: $listingType
                searchId: $searchId
                useGridLayout: $useGridLayout
            }
        ) {
            intercept {
                interceptType
                title
                subtitle
                buttonText
                sort
                ctaUrl
            }
            listings {
                ... on SearchListing {
                    type
                    advertId
                    title
                    subTitle
                    attentionGrabber
                    price
                    vehicleLocation
                    location
                    formattedDistance
                    discount
                    description
                    images
                    numberOfImages
                    priceIndicatorRating
                    rrp
                    manufacturerApproved
                    sellerName
                    sellerType
                    dealerLink
                    dealerReview {
                        overallReviewRating
                        numberOfReviews
                    }
                    fpaLink
                    hasDigitalRetailing
                    preReg
                    finance {
                        monthlyPrice {
                            priceFormattedAndRounded
                        }
                        initialPayment
                        termMonths
                        quoteSubType
                        representativeValues {
                            financeKey
                            financeValue
                        }
                        disclaimerText {
                            components {
                                ... on FinanceListingDisclaimerTextComponent {
                                    text
                                }
                                ... on FinanceListingDisclaimerLinkComponent {
                                    text
                                    link
                                }
                                ... on FinanceListingDisclaimerTitleComponent {
                                    text
                                }
                            }
                        }
                        financeListingProvider
                        rawFinanceFields {
                            deposit
                            term
                            annualMileage
                        }
                    }
                    badges {
                        type
                        displayText
                    }
                    position
                    trackingContext {
                        retailerContext {
                            id
                        }
                        advertContext {
                            id
                            advertiserId
                            advertiserType
                            make
                            model
                            vehicleCategory
                            year
                            condition
                            price
                            searchVersionId
                        }
                        card {
                            category
                            subCategory
                            pageNumber
                            position
                        }
                        advertCardFeatures {
                            condition
                            numImages
                            hasFinance
                            priceIndicator
                            isManufacturedApproved
                            isFranchiseApproved
                        }
                        distance {
                            distance
                            distance_unit
                        }
                    }
                }
                ... on GPTListing {
                    type
                    targetingSegments {
                        name
                        values
                    }
                    areaOfInterest {
                        manufacturerCodes
                    }
                    posId
                }
                ... on LeasingListing {
                    type
                    advertId
                    title
                    subTitle
                    price
                    vatStatus
                    images
                    numberOfImages
                    fpaLink
                    finance {
                        monthlyPrice {
                            priceFormattedAndRounded
                        }
                        representativeExample
                        representativeValues {
                            financeKey
                            financeValue
                        }
                        initialPayment
                        termMonths
                        mileage
                    }
                    badges {
                        type
                        displayText
                    }
                    trackingContext {
                        retailerContext {
                            id
                        }
                        advertContext {
                            id
                            advertiserId
                            advertiserType
                            make
                            model
                            vehicleCategory
                            year
                            condition
                            price
                            searchVersionId
                        }
                        card {
                            category
                            subCategory
                            pageNumber
                            position
                        }
                        advertCardFeatures {
                            condition
                            numImages
                            hasFinance
                            priceIndicator
                            isManufacturedApproved
                            isFranchiseApproved
                        }
                        distance {
                            distance
                            distance_unit
                        }
                    }
                }
            }
            page {
                number
                count
                results {
                    count
                }
            }
            searchInfo {
                isForFinanceSearch
                leasingSummary
            }
            trackingContext {
                searchId
            }
        }
    }
`

export const SearchResultsLeasingListingsGridQueryGql = gql`
    query SearchResultsLeaseListingsGridQuery(
        $filters: [FilterInput!]!
        $channel: Channel!
        $page: Int
        $sortBy: SearchResultsSort
        $searchId: String!
    ) {
        searchResults(
            input: {
                facets: []
                filters: $filters
                channel: $channel
                page: $page
                sortBy: $sortBy
                searchId: $searchId
                useGridLayout: true
            }
        ) {
            listings {
                ... on LeasingListing {
                    type
                    advertId
                    title
                    subTitle
                    price
                    vatStatus
                    images
                    numberOfImages
                    fpaLink
                    finance {
                        monthlyPrice {
                            priceFormattedAndRounded
                        }
                        representativeExample
                        representativeValues {
                            financeKey
                            financeValue
                        }
                        initialPayment
                        termMonths
                        mileage
                    }
                    badges {
                        type
                        displayText
                    }
                    trackingContext {
                        retailerContext {
                            id
                        }
                        advertContext {
                            id
                            advertiserId
                            advertiserType
                            make
                            model
                            vehicleCategory
                            year
                            condition
                            price
                            searchVersionId
                        }
                        card {
                            category
                            subCategory
                            pageNumber
                            position
                        }
                        advertCardFeatures {
                            condition
                            numImages
                            hasFinance
                            priceIndicator
                            isManufacturedApproved
                            isFranchiseApproved
                        }
                        distance {
                            distance
                            distance_unit
                        }
                    }
                }
            }
            page {
                number
                count
                results {
                    count
                }
            }
            searchInfo {
                leasingSummary
            }
            trackingContext {
                searchId
            }
        }
    }
`
